/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/KubernetesEndpointContracts" />
export interface KubernetesCluster {
    context: string;
    url: string;
}

export interface KubernetesClusterData {
    selectedCluster: KubernetesCluster;
    clusterList: KubernetesCluster[];
}

export interface ParseServiceAccountSecretYamlResponse {
    token: string;
    certificate: string;
}
